export const CLOSE = 'baq/sideNav/bulkEditQuantitiesDrawer/CLOSE';
export const OPEN = 'baq/sideNav/bulkEditQuantitiesDrawer/OPEN';
